import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';

const ProcessingChart = ({ data, type = 'bar', title, height = 300 }) => {
  const formatTooltipValue = (value, name) => {
    if (name === 'confidence') {
      return [`${Math.round(value)}%`, 'Confidence'];
    }
    return [value, name];
  };

  const formatXAxisTick = (tickItem) => {
    if (typeof tickItem === 'string' && tickItem?.includes('-')) {
      const date = new Date(tickItem);
      return date?.toLocaleDateString('en-GB', { 
        day: '2-digit', 
        month: 'short' 
      });
    }
    return tickItem;
  };

  const renderBarChart = () => (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
        <XAxis 
          dataKey="date" 
          tick={{ fontSize: 12, fill: 'var(--color-muted-foreground)' }}
          tickFormatter={formatXAxisTick}
        />
        <YAxis tick={{ fontSize: 12, fill: 'var(--color-muted-foreground)' }} />
        <Tooltip 
          contentStyle={{
            backgroundColor: 'var(--color-popover)',
            border: '1px solid var(--color-border)',
            borderRadius: '8px',
            fontSize: '12px'
          }}
          formatter={formatTooltipValue}
        />
        <Bar 
          dataKey="invoices" 
          fill="var(--color-primary)" 
          radius={[4, 4, 0, 0]}
          name="Invoices Processed"
        />
      </BarChart>
    </ResponsiveContainer>
  );

  const renderLineChart = () => (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
        <XAxis 
          dataKey="date" 
          tick={{ fontSize: 12, fill: 'var(--color-muted-foreground)' }}
          tickFormatter={formatXAxisTick}
        />
        <YAxis tick={{ fontSize: 12, fill: 'var(--color-muted-foreground)' }} />
        <Tooltip 
          contentStyle={{
            backgroundColor: 'var(--color-popover)',
            border: '1px solid var(--color-border)',
            borderRadius: '8px',
            fontSize: '12px'
          }}
          formatter={formatTooltipValue}
        />
        <Line 
          type="monotone" 
          dataKey="confidence" 
          stroke="var(--color-success)" 
          strokeWidth={3}
          dot={{ fill: 'var(--color-success)', strokeWidth: 2, r: 4 }}
          name="confidence"
        />
      </LineChart>
    </ResponsiveContainer>
  );

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">{title}</h3>
      <div className="w-full" aria-label={`${title} Chart`}>
        {type === 'line' ? renderLineChart() : renderBarChart()}
      </div>
    </div>
  );
};

export default ProcessingChart;